export { default } from './EmprestimoGarantiaCarroContratoDA';
